let config = {
    /* List all the roles you wish to use in the app
    * You have a max of 31 before the bit shift pushes the accompanying integer out of
    * the memory footprint for an integer
    */
    roles :[
        'public',
        'user',
        'admin'],

    /*
    Build out all the access levels you want referencing the roles listed above
    You can use the "*" symbol to represent access to all roles
     */
    accessLevels : {
        'public' : "*",
        'anon': ['public'],
        'user' : ['user', 'admin'],
        'admin': ['admin']
    }
};

/*
    Method to build a distinct bit mask for each role
    It starts off with "1" and shifts the bit to the left for each element in the
    roles array parameter
 */

function buildRoles(roles) {
    let bitMask = "01";
    let userRoles = {};

    for(let role in roles) {
        let intCode = parseInt(bitMask, 2);
        userRoles[roles[role]] = {
            bitMask: intCode,
            title: roles[role]
        };
        bitMask = (intCode << 1 ).toString(2)
    }

    return userRoles;
}

/*
This method builds access level bit masks based on the accessLevelDeclaration parameter which must
contain an array for each access level containing the allowed user roles.
 */
function buildAccessLevels(accessLevelDeclarations, userRoles) {

    let accessLevels = {};
    for(let level in accessLevelDeclarations) {

        if(typeof accessLevelDeclarations[level] === 'string') {
            if(accessLevelDeclarations[level] === '*'){
                let resultBitMask = '';
                for( let role in userRoles) {
                    resultBitMask += "1"
                }
                //accessLevels[level] = parseInt(resultBitMask, 2);
                accessLevels[level] = {
                    bitMask: parseInt(resultBitMask, 2),
                    title: accessLevelDeclarations[level]
                };
            }
        } else {
            let resultBitMask = 0;
            for(let role in accessLevelDeclarations[level]) {
                if(userRoles.hasOwnProperty(accessLevelDeclarations[level][role])) {
                    resultBitMask = resultBitMask | userRoles[accessLevelDeclarations[level][role]].bitMask;
                }
            }

            accessLevels[level] = {
                bitMask: resultBitMask,
                title: accessLevelDeclarations[level]
            };
        }
    }

    return accessLevels;
};

let userRoles = buildRoles(config.roles);
let accessLevels = buildAccessLevels(config.accessLevels, userRoles);

let routingConfig = {
    userRoles : userRoles,
    accessLevels: accessLevels
};

export { routingConfig };


// WEBPACK FOOTER //
// ./js/authorizationConfig.js